var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    {
      staticClass: "wrapper",
      class: _vm.cssClass,
      attrs: { id: _vm.componentId },
    },
    [
      _c("input", {
        ref: "modelValue",
        class: _vm.cssClass,
        attrs: { placeholder: _vm.placeholder },
        domProps: { value: _vm.value },
        on: {
          input: function ($event) {
            return _vm.modelChange()
          },
          click: function ($event) {
            return _vm.clickOnInput()
          },
        },
      }),
      _c(
        "ul",
        {
          staticClass: "suggestions list-unstyled",
          staticStyle: { display: "none" },
          attrs: { id: _vm.suggestionListId },
        },
        _vm._l(_vm.filteredSuggestions, function (suggestion) {
          return _c(
            "li",
            {
              key: suggestion,
              on: {
                click: function ($event) {
                  return _vm.selected(suggestion.value)
                },
              },
            },
            [_c("span", [_vm._v(_vm._s(suggestion.label))])]
          )
        }),
        0
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }